import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { TabsContent } from "@/components/ui/tabs";
import { login as googleLogin } from "@/context/AuthContext";

export const GoogleButton = () => (
  <Button
    type="button"
    variant="outline"
    onClick={googleLogin}
    data-testid="google-auth-btn"
    className="w-full rounded-full border-[#14140f]/15 hover:bg-[#f5f4f0] gap-2"
  >
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
    Continue with Google
  </Button>
);

export const Divider = () => (
  <div className="flex items-center gap-3 my-4">
    <span className="h-px flex-1 bg-[#14140f]/10" />
    <span className="text-xs uppercase tracking-wider text-[#14140f]/40">or</span>
    <span className="h-px flex-1 bg-[#14140f]/10" />
  </div>
);

// Shared email/password fields; the Name field shows only on the Register tab.
export const AuthFields = ({ tab, form, set }) => {
  const isRegister = tab === "register";
  return (
    <>
      <TabsContent value="register" className="mt-0 space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="auth-name">Name</Label>
          <Input
            id="auth-name"
            data-testid="auth-name-input"
            value={form.name}
            onChange={set("name")}
            placeholder="Your name"
            required={isRegister}
            autoComplete="name"
          />
        </div>
      </TabsContent>

      <div className="space-y-1.5">
        <Label htmlFor="auth-email">Email</Label>
        <Input
          id="auth-email"
          type="email"
          data-testid="auth-email-input"
          value={form.email}
          onChange={set("email")}
          placeholder="you@example.com"
          required
          autoComplete="email"
        />
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="auth-password">Password</Label>
        <Input
          id="auth-password"
          type="password"
          data-testid="auth-password-input"
          value={form.password}
          onChange={set("password")}
          placeholder={isRegister ? "At least 8 characters" : "Your password"}
          required
          minLength={isRegister ? 8 : undefined}
          autoComplete={isRegister ? "new-password" : "current-password"}
        />
      </div>
    </>
  );
};
